import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LimitUsage } from "../../models/limit-usage";

export interface LimitUsageState {
  current: LimitUsage | null;
}

const initialState: LimitUsageState = {
  current: null,
};

export const limitUsageSlice = createSlice({
  name: "limit-usage",
  initialState,
  reducers: {
    setLimitUsage: (state, action: PayloadAction<LimitUsage>) => {
      state.current = action.payload;
    },
    clearLimitUsage: (state) => {
      state.current = null;
    },
  },
});

export const { setLimitUsage, clearLimitUsage } = limitUsageSlice.actions;

export default limitUsageSlice.reducer;
